export function SectionCard({ title, description, icon: Icon, children, actions = null, className = "" }) {
  return (
    <section className={`rounded-lg border border-gray-200 bg-background p-5 shadow-sm ${className}`}>
      <div className="mb-5 flex items-start gap-3">
        {Icon && (
          <span className="rounded-md bg-scale-100 p-2 text-scale-700">
            <Icon size={20} aria-hidden="true" />
          </span>
        )}
        <div>
          <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
          {description && <p className="mt-1 text-sm text-gray-500">{description}</p>}
        </div>
        {!!actions && actions}
      </div>
      {children}
    </section>
  );
}
